import {
  useImperativeHandle,
  forwardRef,
  useState,
  useEffect,
  useRef
} from "react";
import { Row, Col, Form } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { SearchSelect } from "../utility/forms/inputs/search-select";
import { checkTubeProcessAdded } from "./WPSObjects/WPS_Validations";
import { getbyprojectno } from "../../Services/wps_groove-services";
import {
  isAllowCustomSpecialCharacters,
  isAllowDashedPlusSpecialCharacters,
  isAllowDashedSpecialCharacters,
  isAlphanumericAllSpecialCharacters,
} from "../../functions/validations";
import { todayDate, maxDate } from "../utility/common/helpers/TodayDate";
import { company_name, Tubesheet_WPSPage1, joint_type } from "./WPSObjects/WPSGroove_entity";
import { Status, Action } from "../utility/common/constants/CommonConstants";
import { WPSFillerMetals } from "./WPSObjects/WPS_filler_metals";
import { WPS_Base_metals } from "./WPSObjects/WPS_base_metals";
import { emptyError, handleGeneralSubmit, handleGeneralSubmitTemp } from "./WPSObjects/WPSCommonUtils";
import { getAllProject } from "../../Services/project-services";
import { getActiveAno } from "../../Services/ano-services";
import { getActiveSfa } from "../../Services/sfa-service";
import { getActiveFno } from "../../Services/fno-services";
import axios from "axios";
import { getPresignedURL } from "../../Services/Welder-services";
import { AddLogs } from "../../Services/wps-logs-services";
import { errorstyle, normalstyle } from "../../functions/welding-functions";
import { DotLoader } from "react-spinners";
import { validateForm } from "../utility/common/TransactionComponents/TransactionValidationUtils";
import { handleHeaderDetailAdd, handleStatusChange } from "./WPSObjects/WPSDataService";
import { ImageArray3, validateFile } from "../utility/common/TransactionComponents/CommonImages"
import { SingleInput } from "../utility/forms/inputs/InputsTransaction";
import { DateInput } from "../utility/common/helpers/DateComponent";
import { maxlength_WPS } from "./WPSObjects/maxlength_WPS";
import { getdetailsById, DeleteWPS } from "../../Services/wps_details-service";

const WPSTubesheetGeneral = forwardRef(
  (
    {
      headerObj,
      setheaderObj,
      detailObj,
      setdetailObj,
      WPStype,
      setKey,
      tabno,
      setIsEditedPage1,
      logObj,
      isReadonly,
      setReadOnly,
      action,
      setAction
    },
    ref
  ) => {
    const location = useLocation();
    const folderwps = "WPS_Groove";
    const [loading, setLoading] = useState(false);
    const [ProjectDetails, setProjectDetails] = useState([]);
    const [SfaActive, setSfaActive] = useState([]);
    const [FnoActive, setFnoActive] = useState([]);
    const [AnoActive, setAnoActive] = useState([]);

    const [IsEdited, setIsEdited] = useState(false);


    const [previewUrl1, setPreviewUrl1] = useState();
    const [previewUrl2, setPreviewUrl2] = useState();
    const [previewUrl3, setPreviewUrl3] = useState();
    const [profile, setProfile] = useState("");
    const [profile1, setProfile1] = useState("");
    const [profile2, setProfile2] = useState("");



    let isoverlay = WPStype === "Groove" ? false : true;
    let grooveclass = WPStype === "Groove" ? "row-margin" : "d-none";
    let overclass = WPStype !== "Groove" ? "row-margin" : "d-none";

    const [isOverlay, setOverlay] = useState(isoverlay);
    const [Grooveclass, setoverlayclass] = useState(grooveclass);
    const [overlaytext] = useState(overclass);
    const [classError, setClassError] = useState([]);
    const [chemicalAnaError, setChemicalAnaError] = useState([]);



    const [error, setError] = useState({
      WPSH_Project_No: {},
      WPSH_WPS_No: {},
      WPSH_WPS_Revi_No: {},
      WPS_QualifiedTo: {},
      WPSH_SupportingPQR: {},
      WPSH_WPS_Date: {},
      WPSH_RefDoc: {},
      WPSH_BM_BaseMetal1_ProductForm: "",
      WPSH_BM_BaseMetal1_Spec: "",
      WPSH_BM_BaseMetal1_PNo: "",
      WPSH_BM_BaseMetal1_GNo: "",
      WPSH_BM_BaseMetal1_Thick: "",
      WPSH_BM_BaseMetal1_Diam: "",
      WPSH_BM_WeldBaseMetal2_ProductForm: "",
      WPSH_BM_WeldBaseMetal2_Spec: "",
      WPSH_BM_WeldBaseMetal2_PNo: "",
      WPSH_BM_WeldBaseMetal2_GNo: "",
      WPSH_BM_WeldBaseMetal2_Thick: "",
      WPSH_BM_WeldBaseMetal2_Diam: "",
      WPSH_JD_JointType: {},
      WPSH_JD_HoleId: {},
      WPSH_JD_TubePitch: {},
      WPSH_JD_GrooveDepth: {},
      WPSH_JD_TubeProj: {},
      WPSH_JD_WidthLigament: {},
      WPSH_JD_Pattern: {},
      WPSH_JD_GrooveAngle: {},
      WPSH_JD_GrooveType: {},
      WPSH_FM_PreFillerMetal: {},
      WPSH_FM_WithFillerMetal: {},
      WPSH_FM_FillerProduct: {},
      WPSH_FM_Inserts: {},
      WPSH_FM_FillerFlux: {},
      WPSH_FM_FillerOthers: {},
      WPSD_FM_SFA: {},
      WPSD_FM_Classification: {},
      WPSD_FM_FNo: {},
      WPSD_FM_Ano: {},
      WPSD_FM_ChemicalAnalysis_TradeName: {},

    });
    const TubesheetfileMappings = [
      {

        setImage: setProfile,
        previewFn: previewUrl1,
        headerPath: () => headerObj.Pdf_images[0].tube_Hole_ligament,
        imageKey: headerObj.Pdf_images[0].tube_Hole_ligament,
        setPreviewFn: setPreviewUrl1,
        profile: profile
      },
      {
        setImage: setProfile1,
        previewFn: previewUrl2,
        headerPath: () => headerObj.Pdf_images[1].tube_Hole,
        imageKey: headerObj.Pdf_images[1].tube_Hole,
        setPreviewFn: setPreviewUrl2,
        profile: profile1
      },
      {
        setImage: setProfile2,
        previewFn: previewUrl3,
        headerPath: () => headerObj.Pdf_images[2].tube_Weld_Joint,
        imageKey: headerObj.Pdf_images[2].tube_Weld_Joint,
        setPreviewFn: setPreviewUrl3,
        profile: profile2
      },
    ]





    const handleChange = (e) => {
      setIsEdited(true);
      setIsEditedPage1(true);
      const { name, value } = e.target;
      setheaderObj((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    };


    const handleChangedetailsarray = (e, i) => {
      setIsEdited(true);
      setIsEditedPage1(true);
      const { name, value } = e.target;
      const onChangeVal = [...detailObj];
      if (onChangeVal[i]) {
        onChangeVal[i][name] = value;
        setdetailObj(onChangeVal);
      }
    };

    const validate = async () => {
      let isError = false;
      const page1Fields = Tubesheet_WPSPage1;
      const validationResult = validateForm({
        headerObj,
        detailObj,
        requiredFields: { ...page1Fields },
        detailConfig: [],
        currentErrors: error,
        todayDate,
      });
      setError(validationResult.errors);
      isError = validationResult.isError

      let norows = checkTubeProcessAdded(detailObj);
      if (norows && detailObj[0]) {
        detailObj[0].errormessage =
          "Atleast one Tubesheet Process and SFA Type is required";
        isError = true;
        detailObj[0].error = true;
      }

      // Duplicate check - always run for new records
      if (
        (action === Action.ActionCopy || action === Action.ActionAdd)
      ) {
        try {
          const result = await getbyprojectno(WPStype, headerObj.WPSH_Project_No, headerObj.WPSH_WPS_No);
          if (result && result.length > 0) {
            isError = true;
            error.WPSH_Project_No.status = true;
            error.WPSH_Project_No.message = "Project Number & WPS Number already exists";
            setError(prev => ({ ...prev, WPSH_Project_No: error.WPSH_Project_No }));
            return true; // Return immediately to prevent save
          } else {
            error.WPSH_Project_No.status = false;
            error.WPSH_Project_No.message = "";
          }
        } catch (duplicateError) {
        }
      }
      return isError;
    };

    const validateTemp = async () => {
      let isError = false;
      let temperror = emptyError(error, setError, isError);

      if (headerObj.WPSH_Project_No.trim() === "") {
        headerObj.WPSH_Project_No = "";
        isError = true;
        error.WPSH_Project_No = {
          status: true,
          message: "This field is required",
        };
      }
      if (headerObj.WPSH_WPS_No.trim() === "") {
        headerObj.WPSH_WPS_No = "";
        isError = true;
        error.WPSH_WPS_No = {
          status: true,
          message: "This field is required",
        };
      }

      if (headerObj.WPSH_WPS_Date > todayDate) {
        isError = true;
        error.WPSH_WPS_Date = {
          status: true,
          message: "No Future Date Allowed.",
        };
      }
      if (
        (action === Action.ActionCopy || action === Action.ActionAdd) &&
        !isError
      ) {
        try {
          const result = await getbyprojectno(WPStype, headerObj.WPSH_Project_No, headerObj.WPSH_WPS_No);
          if (result && result.length > 0) {
            isError = true;
            error.WPSH_Project_No.status = true;
            error.WPSH_Project_No.message = "Project Number & WPS Number already exists";
          } else {
            error.WPSH_Project_No.status = false;
            error.WPSH_Project_No.message = "";
          }
        } catch (duplicateError) {
        }
      }

      let norows = checkTubeProcessAdded(detailObj);

      if (norows && detailObj[0]) {
        detailObj[0].errormessage = "Atleast one Process and SFA is required";
        isError = true;
        detailObj[0].error = true;

        if (
          detailObj[0].WPSD_Process !== "" &&
          detailObj[0].WPSD_FM_FNo !== "" &&
          detailObj[0].WPSD_FM_SFA !== ""
        ) {
          detailObj[0].error = false;
        }
      }
      return { isError, temperror };
    };

    const handleAdd = async () => {
      let handleaddresult = true;
      let previousStatus = headerObj.WPSH_Status;
      handleStatusChange(headerObj, location, action);
      headerObj.WPSH_WPS_Process = "GTAW"

      // Handle old process deletion for SFA changes (using WPQ pattern)
      try {
        const filteredDetails = detailObj.filter(
          (item) => item.WPSD_Process !== "" && item.WPSD_FM_SFA !== ""
        );

        // Prepare detail data with PK/SK for comparison (WPQ pattern)
        for (const item of filteredDetails) {
          item.PK = headerObj.WPSH_Project_No + "#" + headerObj.WPSH_WPS_No;
          item.SK = item.WPSD_Process + "#" + item.WPSD_FM_SFA;
        }

        // Get existing processes and delete those not in current filtered details
        if (action === Action.ActionEdit) {
          let oldProcess = await getdetailsById(headerObj.WPSH_Project_No, headerObj.WPSH_WPS_No);

          // Delete old processes using WPQ pattern
          for (const item of oldProcess) {
            let NotFoundprocess = filteredDetails.some(
              (detail) => detail.PK.toString() === item.PK.toString() &&
                detail.SK.toString() === item.SK.toString()
            );
            if (!NotFoundprocess) {
              await DeleteWPS(item.PK, item.SK).catch((e) => {
              });
            }
          }
        }
      } catch (error) {
      }

      handleaddresult = handleHeaderDetailAdd(
        headerObj,
        detailObj,
        location
      );

      if (handleaddresult) {
        setAction(Action.ActionEdit);
        if (
          action === Action.ActionEdit &&
          previousStatus === Status.StatusApproved
        ) {
          let logObj = {
            WPSH_Project_No_log:
              headerObj !== undefined ? headerObj.WPSH_Project_No : "",
            WPSH_WPS_No_log: headerObj !== undefined ? headerObj.WPSH_WPS_No : "",
            WPSH_User_Name_log: sessionStorage.getItem("UserName"),
            WPSH_User_Id_log: sessionStorage.getItem("UserId"),
            WPSH_Status_log: "",
          };
          await AddLogs(logObj);
        }
        await handleImageUploads()
      }
      return handleaddresult;
    };

    const handleImageUploads = async () => {
      try {
        for (const mapping of TubesheetfileMappings) {
          const { profile, imageKey, setPreviewFn } = mapping;
          if (imageKey[0] != "" && imageKey[0] != undefined && profile != "") {
            const result = await getPresignedURL(folderwps, imageKey[0]);
            const posturl = result.url;
            setPreviewFn(posturl);
            await axios.put(posturl, profile);
          }
        }
      }
      catch (error) {
        throw error;
      }
    };

    const fetchImagestube = async (item, setPreviewFn) => {
      if (item) {
        const result = await getPresignedURL(folderwps, item);
        const posturl = result.url;
        setPreviewFn(posturl);

      }
    };

    useEffect(() => {

      TubesheetfileMappings.forEach(({ imageKey, setPreviewFn, previewFn }) => {
        if (action === Action.ActionEdit || action === Action.ActionCopy) {
          if (imageKey[0] !== "" && imageKey[0] !== undefined && !previewFn) {
            fetchImagestube(imageKey[0], setPreviewFn);
          }
        }
      });
    }, [tabno, previewUrl1, previewUrl2, previewUrl3]);

    const handleFile1 = (file, index, e) => {
      if (validateFile(file)) {

        if (TubesheetfileMappings[index]) {
          const { setPreviewFn, headerPath, setImage } = TubesheetfileMappings[index];

          setPreviewFn(URL.createObjectURL(file));
          setImage(file)
          headerPath()[0] = file.name;
        }
      }
    };

    const fileInputRef = useRef(null);
    const fetchProject = async () => {
      let result = await getAllProject();
      if (result?.length > 0)
        result = result.filter((item) => item.wld_status === "Active");
      setProjectDetails(result);
    };

    const fetchSfa = async () => {
      const result = await getActiveSfa();
      setSfaActive(result);
    };

    const fetchfno = async () => {
      const result = await getActiveFno();
      setFnoActive(result);
    };

    const fetchAno = async () => {
      const result = await getActiveAno();
      setAnoActive(result);
    };

    useEffect(() => {
      fetchSfa();
      fetchfno();
      fetchAno();
      fetchProject();
    }, []);

    const handleSubmitTemp = () => handleGeneralSubmitTemp(
      IsEdited,
      validateTemp,
      handleAdd,
      setLoading,
      setIsEdited,
      setIsEditedPage1, headerObj.WPSH_Status
    );

    const handleSubmit = () => handleGeneralSubmit(validate, handleAdd, setLoading, setIsEditedPage1
      , headerObj.WPSH_Status);

    useImperativeHandle(ref, () => ({
      funcOnNext: async () => {
        let res = false;
        res = await handleSubmit();
        return res;
      },

      funcOnNextTemp1: async () => {
        let res = false;
        res = await handleSubmitTemp();
        return res;
      },
    }));

    return (
      <Row className="font">
        {loading && (
          <div className="loader-overlay">
            <DotLoader size={80} className="pageloader" />
          </div>
        )}
        <Row style={{ padding: "20px 60px" }} className="WPS-Page-row-padding">
          <Row className="mb-2">
            <Col md={3} style={{ width: "20%" }}>
              <Form.Group className="pro-input-select">
                <div className="search-select">
                  <SearchSelect
                    id="WPSH_Project_No"
                    name="WPSH_Project_No"
                    className={error.WPSH_Project_No.status ? "err-input" : ""}
                    stylegreen={
                      error.WPSH_Project_No.status ? errorstyle : normalstyle
                    }
                    data={ProjectDetails}
                    valueField={"wld_ProjectNumber"}
                    disabled={action === Action.ActionEdit ? true : false}
                    value={headerObj.WPSH_Project_No}
                    labelField={"wld_ProjectNumber"}
                    placeholder=""
                    /**
                     * PROJECT CHANGE HANDLER - ITEM CODE CLEARING LOCATION
                     * 
                     * THIS IS WHERE WPSD_WP_ItemCode GETS CLEARED TO EMPTY STRING
                     * 
                     * PROCESS:
                     * 1. User selects new project from dropdown
                     * 2. This onChange handler executes
                     * 3. Updates headerObj.WPSH_Project_No with new project
                     * 4. Updates detailObj[0].WPSH_Project_No with new project
                     * 5. IMPLICIT CLEARING: When detailObj is updated with new project,
                     *    the existing WPSD_WP_ItemCode arrays become invalid
                     * 6. useEffect in WPSTubesheetProcedureSpec triggers fetchitem()
                     * 7. fetchitem() calls getActiveItemForProject() with new project
                     * 8. ItemActive state updates with new project's items
                     * 9. Previous item selections are no longer valid and appear as ""
                     * 
                     * WHY ITEMS SHOW AS "":
                     * - WPSD_WP_ItemCode contains item codes from previous project
                     * - New project's ItemActive doesn't include old project's items
                     * - Dropdown shows "" because selected value not found in new options
                     * - This forces user to reselect appropriate items for new project
                     * 
                     * CORRECT BEHAVIOR: Prevents cross-project item contamination
                     */
                    onChange={(ProjectList) => {
                      setheaderObj((prev) => ({
                        ...prev,
                        WPSH_Project_No: ProjectList.value,
                      }));
                      setError((prevState) => ({
                        ...prevState,
                        WPSH_Project_No: {},
                      }));
                      if (detailObj[0]) {
                        detailObj[0].WPSH_Project_No = ProjectList.value;
                        detailObj[0].WPSD_WP_ItemCode = []
                        detailObj[0].welddesc = []
                        detailObj[0].weldweight = []
                      }
                      if (action === Action.ActionCopy) {
                        setReadOnly(false)
                      }
                    }}
                    onInput={(e) => {
                      let error = isAlphanumericAllSpecialCharacters(e.target.value);
                      setError((prevState) => ({
                        ...prevState,
                        WPSH_Project_No: error,
                      }));
                    }}
                  ></SearchSelect>
                </div>
                <Form.Label>Project Number</Form.Label>
                <div className="required-text-select">
                  {error.WPSH_Project_No.status && (
                    <Form.Text className="text-danger">
                      {error.WPSH_Project_No.message}
                    </Form.Text>
                  )}
                </div>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group style={{ width: "201px" }}>
                <SingleInput
                  disabled={action === Action.ActionEdit ? true : false}
                  name="WPSH_WPS_No"
                  type="text"
                  maxLength={17}
                  status={error.WPSH_WPS_No.status}
                  value={headerObj.WPSH_WPS_No}
                  onChange={(e) => {
                    handleChange(e);
                    if (detailObj[0]) {
                      detailObj[0].WPSH_WPS_No = e.target.value;
                    }
                    if (action === Action.ActionCopy) {
                      setReadOnly(false);
                    }
                  }
                  }
                  label="WPS No."
                  message={error.WPSH_WPS_No.message}
                  error={error}
                  setError={setError}
                  allowlistfunction={isAllowDashedSpecialCharacters}
                  customMessage="Special Characters # & % $ ' < > = ; not allowed"
                ></SingleInput>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <SingleInput
                  disabled={isReadonly}
                  name="WPSH_WPS_Revi_No"
                  type="text"
                  maxLength={3}
                  status={error.WPSH_WPS_Revi_No.status}
                  value={headerObj.WPSH_WPS_Revi_No}
                  onChange={handleChange}
                  label="WPS Rev.No."
                  message={error.WPSH_WPS_Revi_No.message}
                  error={error}
                  setError={setError}
                ></SingleInput>
              </Form.Group>
            </Col>
            <Col md={3} style={{ width: "255px" }}>
              <DateInput
                divClass="T-input w-100"
                label="WPS Date"
                className="groove_datecolor"
                name="WPSH_WPS_Date"
                todayDate={todayDate}
                maxDate={maxDate}
                disabled={isReadonly}
                obj={headerObj}
                setobj={setheaderObj}
                setError={setError}
                status={error.WPSH_WPS_Date.status}
                message={error.WPSH_WPS_Date.message}
              />
            </Col>
            <SingleInput
              divstyle="T-input w-100"
              id="WPSH_SupportingPQR"
              name="WPSH_SupportingPQR"
              label="Supporting PQR"
              maxLength={maxlength_WPS.WPSH_SupportingPQR}
              status={error.WPSH_SupportingPQR.status}
              message={error.WPSH_SupportingPQR.message}
              value={headerObj.WPSH_SupportingPQR}
              onChange={handleChange}
              setError={setError}
              error={error}
              allowlistfunction={isAllowCustomSpecialCharacters}
              allowcharacters="-"
              customMessage="Special Characters # & % + $ ' < > = ; not allowed"
            />
          </Row>
          <Row className="row-margin">
            <SingleInput
              md={6}
              divstyle="T-input w-100"
              id="WPSH_RefDoc"
              name="WPSH_RefDoc"
              label="Reference Docs"
              maxLength={maxlength_WPS.WPSH_RefDoc}
              status={error.WPSH_RefDoc.status}
              message={error.WPSH_RefDoc.message}
              value={headerObj.WPSH_RefDoc}
              onChange={handleChange}
              setError={setError}
              error={error}
              allowlistfunction={isAllowCustomSpecialCharacters}
              allowcharacters="-"
              customMessage="Special Characters # & % + $ ' < > = ; not allowed"
            />
            <SingleInput
              divstyle="T-input w-100"
              md={3}
              style={{ position: "relative", left: "8px" }}
              id="WPS_QualifiedTo"
              name="WPS_QualifiedTo"
              label="Qualified To"
              disabled={isReadonly}
              maxLength={maxlength_WPS.WPS_QualifiedTo}
              status={error.WPS_QualifiedTo.status}
              message={error.WPS_QualifiedTo.message}
              value={headerObj.WPS_QualifiedTo}
              onChange={handleChange}
              setError={setError}
              error={error}
              allowlistfunction={isAllowCustomSpecialCharacters}
              allowcharacters="-"
              customMessage="Special Characters # & % + $ ' < > = ; not allowed"
            />

            <Col>
              <div className="T-input w-100">
                <input
                  type="text"
                  id="WPSH_CompanyName"
                  name="WPSH_CompanyName"
                  value={company_name[0].value}
                  readOnly
                  disabled={isReadonly}
                  placeholder=" "
                />
                <Form.Label htmlFor="WPSH_CompanyName">Company Name</Form.Label>
              </div>
            </Col>
          </Row>
        </Row>

        <Row style={{ padding: "10px 48px" }}>
          <Col md={12}>
            <p className="WPS-blue-text"> BASE METALS ( QW-403)</p>
            <WPS_Base_metals
              headerObj={headerObj}
              error={error}
              readOnly={isReadonly}
              disabled={isReadonly}
              handleChange={handleChange}
              setError={setError}
            ></WPS_Base_metals>
          </Col>
        </Row>

        <Row style={{ padding: "20px 60px" }} className="WPS-Page-row-padding">
          <span className="WPS-blue-text" style={{ position: "relative", right: "12px" }}>Joint Detail</span>
          <Row className="mb-4">
            <Col>
              <div className="T-input w-100">
                <input
                  type="text"
                  id="WPSH_JD_JointType"
                  name="WPSH_JD_JointType"
                  value={joint_type[0].value}
                  readOnly
                  placeholder=" "
                />
                <Form.Label htmlFor="WPSH_JD_JointType">Joint Type</Form.Label>
              </div>
            </Col>

            <SingleInput
              disabled={isReadonly}
              name="WPSH_JD_HoleId"
              type="text"
              maxLength={20}
              status={error.WPSH_JD_HoleId.status}
              value={headerObj.WPSH_JD_HoleId}
              onChange={handleChange}
              label="Hole ID (mm)"
              message={error.WPSH_JD_HoleId.message}
              error={error}
              setError={setError}
              allowlistfunction={isAllowDashedPlusSpecialCharacters}
              customMessage="Special Characters # & % $ ' < > = ; not allowed"
            ></SingleInput>
          </Row>
          <Row className="mb-4">


            <SingleInput
              disabled={isReadonly}
              name="WPSH_JD_TubePitch"
              type="text"
              maxLength={20}
              status={error.WPSH_JD_TubePitch.status}
              value={headerObj.WPSH_JD_TubePitch}
              onChange={handleChange}
              label="Tube Pitch (mm)"
              message={error.WPSH_JD_TubePitch.message}
              error={error}
              setError={setError}
              allowlistfunction={isAllowCustomSpecialCharacters}
              allowcharacters="+&=±-"
              customMessage="Special Characters # % $ ' < > ; not allowed"
            ></SingleInput>


            <SingleInput
              disabled={isReadonly}
              name="WPSH_JD_GrooveDepth"
              type="text"
              maxLength={20}
              status={error.WPSH_JD_GrooveDepth.status}
              value={headerObj.WPSH_JD_GrooveDepth}
              onChange={handleChange}
              label="Groove Depth (mm)"
              message={error.WPSH_JD_GrooveDepth.message}
              error={error}
              setError={setError}
              allowlistfunction={isAllowCustomSpecialCharacters}
              allowcharacters="+&=±-"
              customMessage="Special Characters # % $ ' < > ; not allowed"

            ></SingleInput>


          </Row>
          <Row className="mb-4">


            <SingleInput
              disabled={isReadonly}
              name="WPSH_JD_TubeProj"
              type="text"
              maxLength={20}
              status={error.WPSH_JD_TubeProj.status}
              value={headerObj.WPSH_JD_TubeProj}
              onChange={handleChange}
              label="Tube Projection (mm)"
              message={error.WPSH_JD_TubeProj.message}
              error={error}
              setError={setError}
              allowlistfunction={isAllowCustomSpecialCharacters}
              allowcharacters="+&=±-"
              customMessage="Special Characters # % $ ' < > ; not allowed"
            ></SingleInput>


            <SingleInput
              disabled={isReadonly}
              name="WPSH_JD_WidthLigament"
              type="text"
              maxLength={20}
              status={error.WPSH_JD_WidthLigament.status}
              value={headerObj.WPSH_JD_WidthLigament}
              onChange={handleChange}
              label="Width of Ligament (mm)"
              message={error.WPSH_JD_WidthLigament.message}
              error={error}
              setError={setError}
              allowlistfunction={isAllowCustomSpecialCharacters}
              allowcharacters="+&=±-"
              customMessage="Special Characters # % $ ' < > ; not allowed"
            ></SingleInput>

          </Row>
          <Row className="mb-4">
            <SingleInput
              disabled={isReadonly}
              name="WPSH_JD_Pattern"
              type="text"
              maxLength={20}
              status={error.WPSH_JD_Pattern.status}
              value={headerObj.WPSH_JD_Pattern}
              onChange={handleChange}
              label="Pattern"
              message={error.WPSH_JD_Pattern.message}
              error={error}
              setError={setError}
              allowlistfunction={isAllowCustomSpecialCharacters}
              allowcharacters="+&=±-"
              customMessage="Special Characters # % $ ' < > ; not allowed"
            ></SingleInput>
            <SingleInput
              disabled={isReadonly}
              name="WPSH_JD_GrooveAngle"
              type="text"
              maxLength={20}
              status={error.WPSH_JD_GrooveAngle.status}
              value={headerObj.WPSH_JD_GrooveAngle}
              onChange={handleChange}
              label="Groove Angle(°)/Radius(mm)"
              message={error.WPSH_JD_GrooveAngle.message}
              error={error}
              setError={setError}
              allowlistfunction={isAllowCustomSpecialCharacters}
              allowcharacters="+&=±-"
              customMessage="Special Characters # % $ ' < > ; not allowed"
            ></SingleInput>
          </Row>
          <Row className="mb-4">
            <SingleInput
              disabled={isReadonly}
              name="WPSH_JD_GrooveType"
              type="text"
              maxLength={20}
              status={error.WPSH_JD_GrooveType.status}
              value={headerObj.WPSH_JD_GrooveType}
              onChange={handleChange}
              label="Groove Type"
              message={error.WPSH_JD_GrooveType.message}
              error={error}
              setError={setError}
              allowlistfunction={isAllowCustomSpecialCharacters}
              allowcharacters="+&=±-"
              customMessage="Special Characters # % $ ' < > ; not allowed"
            ></SingleInput>
          </Row>
        </Row>
        <Row style={{ padding: "20px 60px" }}>
          <div className="row">
            <span className="WPS-blue-text col-md-4">Tube Hole Ligament Detail</span>
            <span className="WPS-blue-text col-md-4">Tube Hole Detail</span>
            <span className="WPS-blue-text col-md-4"> Tube to Tubesheet Weld Joint Detail </span>
          </div>
          <ImageArray3
            setPreviewUrl1={setPreviewUrl1}
            setPreviewUrl2={setPreviewUrl2}
            setPreviewUrl3={setPreviewUrl3}
            previewUrl1={previewUrl1}
            previewUrl2={previewUrl2}
            previewUrl3={previewUrl3}
            headerObj={headerObj}
            setheaderObj={setheaderObj}
            name="fileInput"
            name1="fileInput1"
            name2="fileInput2"
            name3="fileInput3"
            type="file"
            accept="image/*"
            fileInputRef={fileInputRef}
            readOnly={isReadonly}
            disabled={isReadonly}
            handleFile={handleFile1}
          ></ImageArray3>
        </Row>
        <Row style={{ padding: "20px 48px" }}>
          <Col md={12}>
            <p className="WPS-blue-text">Filler Metals (QW-404)</p>
            <WPSFillerMetals
              headerObj={headerObj}
              detailObj={detailObj}
              disabled={isReadonly}
              error={error}
              readOnly={isReadonly}
              handleChangedetailsarray={handleChangedetailsarray}
              setError={setError}
              setdetailObj={setdetailObj}
              SfaActive={SfaActive}
              AnoActive={AnoActive}
              FnoActive={FnoActive}
              classError={classError}
              setClassError={setClassError}
              chemicalAnaError={chemicalAnaError}
              setChemicalAnaError={setChemicalAnaError}
              isOverlay={isOverlay}
              setOverlay={setOverlay}
              GrooveclassName={Grooveclass}
              setoverlayclassName={setoverlayclass}
              overlaytext={overlaytext}
              action={action}
              setAction={setAction}
              setIsEdited={setIsEdited}
            ></WPSFillerMetals>
          </Col>
        </Row>
        <Row style={{ padding: "20px 60px" }} className="WPS-Page-row-padding">
          <Row className="mb-4">
            <SingleInput
              disabled={isReadonly}
              name="WPSH_FM_PreFillerMetal"
              type="text"
              maxLength={40}
              status={error.WPSH_FM_PreFillerMetal.status}
              value={headerObj.WPSH_FM_PreFillerMetal}
              onChange={handleChange}
              label=" Preplaced Filler Metal"
              message={error.WPSH_FM_PreFillerMetal.message}
              error={error}
              setError={setError}
            ></SingleInput>
            <SingleInput
              disabled={isReadonly}
              name="WPSH_FM_WithFillerMetal"
              type="text"
              maxLength={40}
              status={error.WPSH_FM_WithFillerMetal.status}
              value={headerObj.WPSH_FM_WithFillerMetal}
              onChange={handleChange}
              label="With/ Without Filler Metal"
              message={error.WPSH_FM_WithFillerMetal.message}
              error={error}
              setError={setError}
            ></SingleInput>
            <SingleInput
              disabled={isReadonly}
              name="WPSH_FM_FillerProduct"
              type="text"
              maxLength={40}
              status={error.WPSH_FM_FillerProduct.status}
              value={headerObj.WPSH_FM_FillerProduct}
              onChange={handleChange}
              label=" Filler Metal Product Form"
              message={error.WPSH_FM_FillerProduct.message}
              error={error}
              setError={setError}

            ></SingleInput>
            <SingleInput
              disabled={isReadonly}
              name="WPSH_FM_Inserts"
              type="text"
              maxLength={40}
              status={error.WPSH_FM_Inserts.status}
              value={headerObj.WPSH_FM_Inserts}
              onChange={handleChange}
              label="Inserts"
              message={error.WPSH_FM_Inserts.message}
              error={error}
              setError={setError}

            ></SingleInput>
          </Row>
          <Row className="mb-4">
            <SingleInput
              disabled={isReadonly}
              name="WPSH_FM_FillerFlux"
              type="text"
              maxLength={40}
              status={error.WPSH_FM_FillerFlux.status}
              value={headerObj.WPSH_FM_FillerFlux}
              onChange={handleChange}
              label="Filler Metals - Flux"
              message={error.WPSH_FM_FillerFlux.message}
              error={error}
              setError={setError}

            ></SingleInput>
            <SingleInput
              disabled={isReadonly}
              name="WPSH_FM_FillerOthers"
              type="text"
              maxLength={90}
              status={error.WPSH_FM_FillerOthers.status}
              value={headerObj.WPSH_FM_FillerOthers}
              onChange={handleChange}
              label="Filler Metals - Others"
              message={error.WPSH_FM_FillerOthers.message}
              error={error}
              setError={setError}
            ></SingleInput>
          </Row>
        </Row>
      </Row>
    );
  }
);

export default WPSTubesheetGeneral;